import { useShallow } from 'zustand/react/shallow';
import useProductActionsStore from '../../../../../stores/ProductActionsStore/productActions.store';
import {
  ShopByOutcome,
  ShopByResultOutput,
} from '../../../../products/repositories/types/productActions.types';

const useProductAddedNotification = () => {
  const { openProductNotification, setOrderProducts } = useProductActionsStore(
    useShallow((state) => ({
      openProductNotification: state.openProductNotification,
      setOrderProducts: state.setOrderProducts,
    })),
  );

  const notifyOutcome = (data: ShopByResultOutput) => {
    if (data.outcome !== ShopByOutcome.ADDED || !data.orderProducts?.length) {
      return;
    }

    setOrderProducts(data.orderProducts);
    openProductNotification({
      productAdd: true,
      productAlready: false,
      isOrderProductsApplied: true,
    });
  };

  return { notifyOutcome };
};

export default useProductAddedNotification;
